const maxParameterLength = 2048

// Keep click/linker continuity without replaying manual campaign UTMs on later events.
const passthroughParameters = [
  'gclid',
  'dclid',
  'gclsrc',
  'wbraid',
  'gbraid',
  'gad',
  'gad_source',
  'gad_campaignid',
  'srsltid',
  'msclkid',
  'fbclid',
  '_gl'
]

function isValidParameter(value) {
  return typeof value === 'string'
    && value !== ''
    && value.length <= maxParameterLength
    && !/[\u0000-\u001F\u007F]/.test(value)
}

export function withAttributionPassthrough(url, browser = {}) {
  const location = browser.location ?? window.location
  const documentObject = browser.document ?? document
  let currentUrl
  let destination

  try {
    currentUrl = new URL(location.href)
    destination = new URL(url, location.href)
  } catch {
    return url
  }

  if (destination.origin !== currentUrl.origin) {
    return destination.href
  }

  passthroughParameters.forEach(name => {
    const fields = documentObject.querySelectorAll(
      `form input[type="hidden"][name="${name}"]`
    )
    const formValue = Array.from(fields)
      .map(field => field.value)
      .find(isValidParameter)
    const queryValue = currentUrl.searchParams.get(name)
    const value = formValue ?? queryValue

    if (isValidParameter(value)) {
      destination.searchParams.set(name, value)
    }
  })

  return destination.href
}

export function navigateWithAttribution(url, options = {}, browser = {}) {
  const location = browser.location ?? window.location
  const destination = withAttributionPassthrough(url, browser)

  if (options.replace === true) {
    location.replace(destination)
    return
  }

  location.assign(destination)
}
